"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const life_table_1 = require("./life-table");
const life_expectancy_1 = require("./life-expectancy");
const survival_to_age_1 = require("./survival-to-age");
const data_1 = require("../data");
const errors_1 = require("../errors");
const model_1 = require("../model/model");
const core_decorators_1 = require("core-decorators");
const memoize_one_1 = tslib_1.__importDefault(require("memoize-one"));
let LifeTableFunctions = class LifeTableFunctions {
    constructor(model, genderSpecificRefLifeTable, useExFromAge = 99) {
        this.getCompleteLifeTable = memoize_one_1.default((data) => {
            return life_table_1.getCompleteLifeTableForDataUsingAlgorithm(this.getRefLifeTable(data), data, this.model.getAlgorithmForData(data), this.useExFromAge);
        });
        this.model = model;
        this.genderSpecificRefLifeTable = genderSpecificRefLifeTable;
        this.useExFromAge = useExFromAge;
    }
    getLifeExpectancy(data) {
        const algorithm = this.model.getAlgorithmForData(data);
        if ('bins' in algorithm && algorithm.bins !== undefined) {
            const binData = algorithm.bins.getBinDataForScore(algorithm.calculateScore(data));
            return binData.find(binDatum => {
                return binDatum.survivalPercent === 50;
            }).time;
        }
        else {
            return life_expectancy_1.getLifeExpectancyForAge(Number(data_1.findDatumWithName('age', data).coefficent), this.getCompleteLifeTable(data));
        }
    }
    getSurvivalToAge(data, toAge) {
        return survival_to_age_1.getSurvivalToAge(this.getCompleteLifeTable(data), toAge);
    }
    getRefLifeTable(data) {
        const sex = data_1.findDatumWithName('sex', data).coefficent;
        const refLifeTable = this.genderSpecificRefLifeTable[sex];
        if (refLifeTable) {
            return refLifeTable;
        }
        else {
            throw new errors_1.NoLifeTableFoundError(sex);
        }
    }
};
LifeTableFunctions = tslib_1.__decorate([
    core_decorators_1.autobind,
    tslib_1.__metadata("design:paramtypes", [model_1.Model, Object, Number])
], LifeTableFunctions);
exports.LifeTableFunctions = LifeTableFunctions;
//# sourceMappingURL=life-table-functions.js.map